import { type FC } from 'react';

import { SliderBlock } from 'shared/components/SliderBlock';

import { AwardCard } from './internal/components/AwardCard';
import { AwardsSources, type TAwardsSource } from './internal/components/AwardsSources';
import { trackShowAwardsBlock } from './internal/tracking';

type TAward = {
  title: string;
  imageUrl: string;
};

type TAwardsProps = {
  awardsLabel: string;
  awardsSources: TAwardsSource[];
  awards: TAward[];
};

export const Awards: FC<TAwardsProps> = ({ awardsSources, awardsLabel, awards }) => {
  return (
    <SliderBlock
      id="awards"
      sourceLabel={awardsLabel}
      sourceTooltip={<AwardsSources sources={awardsSources} />}
      title="Награды"
      onShow={trackShowAwardsBlock}
    >
      {awards.map((award, index) => (
        <AwardCard image={award.imageUrl} key={index} title={award.title} />
      ))}
    </SliderBlock>
  );
};
